import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import LocationsMap from './components/LocationsMap';
import Fragment from 'vue-fragment';
Vue.use(Fragment.Plugin)

/*=============================
=       Lazy Load Images      =
=============================*/

document.addEventListener('DOMContentLoaded', function() {

	document.querySelectorAll('.campaign #hero .not-lazy').forEach(function(img) {
        if (img.querySelector('img')) {
            imgLazyLoad(img.querySelector('img'), 300)
        }
    })

	var heroImages = [].slice.call(document.querySelectorAll('#hero .bg-container, #hero .hero-video')),
		lazyImages = [].slice.call(document.querySelectorAll('main img:not(.not-lazy), main .bg-container:not(.first), footer img')),
		active = false,
		heroLazyLoad = function() {
			heroImages.forEach(function(img) {
				imgLazyLoad(img, 300);

				heroImages = heroImages.filter(function(image) {
					return image !== img;
				});

				if(heroImages.length === 0) {
					document.removeEventListener('scroll', heroLazyLoad);
					window.removeEventListener('resize', heroLazyLoad);
					window.removeEventListener('orientationchange', heroLazyLoad);
				}
			});
		};

	// Hero Images
	setTimeout(heroLazyLoad, 1);

	// Regular Images
	var lazyLoad = function() {
		if(active === false) {
			active = true;

			setTimeout(function() {
				lazyImages.forEach(function(img) {
					if((img.getBoundingClientRect().top <= (window.innerHeight + 300) && img.getBoundingClientRect().bottom >= 0) && getComputedStyle(img).display !== 'none') {
						imgLazyLoad(img, (img.classList.contains('bg-container') ? 300 : 0));

						lazyImages = lazyImages.filter(function(image) {
							return image !== img;
						});

						if(lazyImages.length === 0) {
							document.removeEventListener('scroll', lazyLoad);
							window.removeEventListener('resize', lazyLoad);
							window.removeEventListener('orientationchange', lazyLoad);
						}
					}
				});

				active = false;
			}, 200);
		}
	};

	document.addEventListener('scroll', lazyLoad);
	window.addEventListener('resize', heroLazyLoad);
	window.addEventListener('resize', lazyLoad);
	window.addEventListener('orientationchange', heroLazyLoad);
	window.addEventListener('orientationchange', lazyLoad);
});

function imgLazyLoad(img, delay) {
	var url = img.getAttribute('data-src'+(checkWidth(768) && img.hasAttribute('data-src-mobile') ? '-mobile' : ''));

	if(img.tagName == 'IMG' || img.tagName == 'VIDEO' || img.tagName == 'IFRAME')
		img.src = url;
	else
		img.style.backgroundImage = 'url('+url+')';

	setTimeout(function() {
		img.classList.add('loaded');
	}, delay);
}

/*=============================
=        Keyboard Focus       =
=============================*/

document.addEventListener('keydown', function(e) {
	if(e.keyCode == 9 && !body.classList.contains('tabbing'))
		body.classList.add('tabbing');
});

document.addEventListener('mousedown', function() {
	if(body.classList.contains('tabbing'))
		body.classList.remove('tabbing');
});

/*=============================
=         Sticky Header       =
=============================*/

var stickyHeader = new Waypoint({
	element: document.querySelector('#hero .hero-figure, .breadcrumbs, h1'),
	handler: function(direction) {
		var down = direction == 'down';

		if(down)
			body.classList.add('sticky');
		else
			body.classList.remove('sticky');
	},
	offset: header.offsetHeight
});

var lastScrollTop = 0;

window.addEventListener('scroll', function() {
	if(checkWidth(480) && body.classList.contains('sticky') && topbar) {
		var st = window.pageYOffset || document.documentElement.scrollTop;

		if(st > lastScrollTop)
			topbar.classList.add('hide');
		else
			topbar.classList.remove('hide');

		lastScrollTop = st <= 0 ? 0 : st;
	}
});

/*=============================
=             Menu            =
=============================*/

var menu = document.getElementById('menu'),
	mobileMenuButton = document.getElementById('mobile-menu-button');

body.addEventListener('click', function(e) {
	checkAndCloseMenu(e.target);
});

menu.addEventListener('mouseleave', function(e) {
	if(!checkWidth(1200))
		checkAndCloseMenu(menu);
});

document.addEventListener('keydown', function(e) {
	if(e.key == 'Escape')
		checkAndCloseMenu(menu);
});

function checkAndCloseMenu(e) {
	var open = openMenu(e);

	if(open) {
		closeMenu(open);
		toggleMenuBodyClass(false);
	}
}

[].slice.call(header.querySelectorAll('button:not([type="submit"]):not(.close-announcements), a.has-submenu .plus')).forEach(function(navLink) {
	navLink.addEventListener(checkWidth(1200) ? 'click' : 'mouseenter', function(e) {
		var isPlus = this.classList.contains('plus'),
			button = isPlus ? this.parentNode : this;

		if(isPlus)
			e.preventDefault();

		toggleMenu(button);
	});
});

[].slice.call(header.querySelectorAll('a.has-submenu')).forEach(function(navLink) {
	navLink.addEventListener('mouseenter', function() {
		if(!checkWidth(1200))
			toggleMenu(this);
	});
});

function toggleMenu(button) {
	closeMenu(openMenu(button));

	var parent = button.parentNode.parentNode,
		openSibling = parent.querySelector('.open');

	if(parent.classList.contains('submenu') && openSibling && openSibling != button)
		closeMenu(openSibling);

	Velocity(button.nextElementSibling, (button.classList.contains('open') ? 'slideUp' : 'slideDown'), {duration: button == mobileMenuButton ? 300 : 150});

	button.classList.toggle('open');

	button.setAttribute('aria-expanded', (button.getAttribute('aria-expanded') == 'true' ? 'false' : 'true'));

	toggleMenuBodyClass(mobileMenuButton.classList.contains('open'));
}

function closeMenu(el) {
	if(el) {
		var submenu = el.nextElementSibling;

		Velocity(submenu, 'slideUp', {duration: el == mobileMenuButton ? 300 : 150});

		el.classList.remove('open');

		closeMenu(submenu.querySelector('.open'));
	}
}

function openMenu(el) {
	if(mobileMenuButton && mobileMenuButton.classList.contains('open') && mobileMenuButton != el && !mobileMenuButton.contains(el) && !document.getElementById('menu-container').contains(el))
		return mobileMenuButton;

	var openButton = header.querySelector('button:not(#mobile-menu-button).open, a.open');

	return openButton && !openButton.parentNode.contains(el) ? openButton : false;
}

function toggleMenuBodyClass(open) {
	if(open)
		body.classList.add('menu-open');
	else
		body.classList.remove('menu-open');

	setFocus((open ? true : false), header);
}

window.setFocus = function setFocus(open, container) {
	[].slice.call(document.querySelectorAll('#header, #hero, #main, #footer')).forEach(function(parent) {
		if(parent != container) {
			parent.setAttribute('aria-hidden', open);

			[].slice.call(parent.querySelectorAll('a, button, input')).forEach(function(link) {
				if(open)
					link.setAttribute('tabindex', '-1');
				else
					link.removeAttribute('tabindex');
			});
		}
	});
}

/*=============================
=        Skip to Content      =
=============================*/

var skipLink = document.getElementById('skip-link');

skipLink.addEventListener('click', function(e) {
	e.preventDefault();

	var firstLink = document.querySelector('#hero a, main a');

	if(firstLink) {
		scrollToElement(firstLink);
		firstLink.focus();
	}
});

window.skipLinkToggleDisplay = function skipLinkToggleDisplay(hide) {
	skipLink.style.display = hide ? 'none' : '';
}

/*=============================
=        Scroll To Link       =
=============================*/

var scrollLinks = [].slice.call(document.querySelectorAll('.scroll-link'));

scrollLinks.forEach(function(scrollLink) {
	scrollLink.addEventListener('click', function(e) {
		if(this.tagName == 'A')
			e.preventDefault();

		scrollToElement(document.querySelector(this.getAttribute('href')));
	});
});

var sectionId = window.location.hash,
	section = sectionId ? document.querySelector(sectionId) : false;

if(section) {
	setTimeout(function() {
		scrollToElement(section);
	}, 300);

	if(section.parentNode.classList.contains('accordion')) {
		setTimeout(function() {
			Velocity(section.querySelector('.answer'), 'slideDown', {duration: 250});

			var button = section.querySelector('button');

			button.classList.add('open');

			button.setAttribute('aria-expanded', 'true');
		}, 1200);
	}
}

/*=============================
=         Element Link        =
=============================*/

var links = [].slice.call(document.querySelectorAll('.link'));

links.forEach(function(link) {
	link.addEventListener('click', function(e) {
		if(e.target.tagName !== 'A' && this.hasAttribute('data-href')) {
			var href = this.dataset.href;

			if(href.indexOf(location.host) == -1)
				window.open(href);
			else
				window.location.href = href;
		}
	});
});

/*=============================
=        Announcements        =
=============================*/

var announcementsContainer = document.getElementById('announcements'),
	domain = window.location.hostname;

if(announcementsContainer) {
	announcementsContainer.querySelector('.close-announcements').addEventListener('click', function() {
		announcementsContainer.classList.toggle('closed');

		var isClosed = announcementsContainer.classList.contains('closed');

		if(isClosed)
			Cookie.set('announcements', 'closed', {domain: domain});
		else
			Cookie.remove('announcements', {domain: domain});

		this.setAttribute('aria-label', (isClosed ? 'Open' : 'Close') + ' Announcements');
	});
}

/*=============================
=          Accordion          =
=============================*/

var accordions = [].slice.call(document.querySelectorAll('.accordion button'));

accordions.forEach(function(accordion) {
	accordion.addEventListener('click', function() {
		var answer = this.nextSibling,
			animation = window.getComputedStyle(answer).display == 'block' ? 'slideUp' : 'slideDown';

		closeAccordion(this);

		Velocity(answer, animation, {duration: 250});

		this.classList.toggle('open');

		this.setAttribute('aria-expanded', (this.getAttribute('aria-expanded') == 'true' ? 'false' : 'true'));

		// setTimeout(function() {
		// 	scrollToElement(this.parentNode);
		// }, 250);
	});
});

function closeAccordion(el) {
	var openAccordion = el.parentElement.parentElement.querySelector('.open');

	if(openAccordion && openAccordion !== el) {
		Velocity(openAccordion.nextSibling, 'slideUp', {duration: 250});

		openAccordion.classList.toggle('open');
	}
}

/*=============================
=       Google Translate      =
=============================*/

// var languageSwitchers = [].slice.call(document.querySelectorAll('.language-picker-container button'));

// languageSwitchers.forEach(function(switcher) {
// 	switcher.addEventListener('click', function(e) {
// 		var parent = this.parentNode,
// 			list = parent.querySelector('ul');

// 		closeDropDown(parent, e);

// 		parent.classList.toggle('open');

// 		Velocity(list, (window.getComputedStyle(list).display == 'block' ? 'slideUp' : 'slideDown'), {duration: 150});
// 	});

// 	if(typeof Cookie.get('googtrans')!=='undefined') {
// 		switcher.innerHTML = Cookie.get('language-text');
// 	}
// });

// body.addEventListener('click', function(e) {
// 	closeDropDown(this, e);
// });

// function closeDropDown(el, e) {
// 	var open = document.querySelector('.language-picker-container.open');

// 	if(open) {
// 		if(open !== el && !open.contains(e.target)) {
// 			open.classList.remove('open');
// 			Velocity(open.querySelector('ul'), 'slideUp', {duration: 150});
// 		}
// 	}
// }

var languages = [].slice.call(document.querySelectorAll('.language-picker-container a:not(.all)'));

languages.forEach(function(language) {
	language.addEventListener('click', function(e) {
		e.preventDefault();

		var lang = this.getAttribute('hreflang');

		if(Cookie.get('language') !== lang) {
			googTransHandle(false, lang);

			var splitDomain = location.host.split('.');

			if(splitDomain.length > 2)
				googTransHandle(location.host.replace(splitDomain[0], ''), lang);

			window.location.reload();
		}
	});
});

function googTransHandle(domain, lang) {
	if(!domain) {
		if(typeof Cookie.get('googtrans')!=='undefined') {
			Cookie.remove('language');
			Cookie.remove('googtrans');
		}
		if(lang!=='en') {
			Cookie.set('language', lang);
			Cookie.set('googtrans', '/en/'+lang);
		} 
	} else {
		if(typeof Cookie.get('googtrans', {domain: domain})!=='undefined') {
			Cookie.remove('language', {domain: domain});
			Cookie.remove('googtrans', {domain: domain});
		}
		if(lang!=='en') {
			Cookie.set('language', lang, {domain: domain});
			Cookie.set('googtrans', '/en/'+lang, {domain: domain});
		}
	}
}

/*=============================
=             Modal           =
=============================*/

var modals = [].slice.call(document.querySelectorAll('div[role="dialog"]:not(.gm-style-iw)')),
	ieModal = document.getElementById('ie-modal'),
	videoModalButton;

window.videoModal = document.getElementById('video-modal');

modals.forEach(function(modal) {
	modal.addEventListener('click', function(e) {
		if(e.target == modal.querySelector('.close-modal') || !modal.querySelector('.content').contains(e.target))
			closeModal();
	});
});

function closeModal() {
	modals.forEach(function(modal) {
		if(window.getComputedStyle(modal).display == 'block')
			Velocity(modal, {opacity: [0,1]}, {duration: 300, display: 'none'});

		if(modal == videoModal) {
			setTimeout(function() {
				videoModal.querySelector('.video-container').innerHTML = '';

				skipLinkToggleDisplay(false);
				setFocus(false, false);

				if(videoModalButton)
                    videoModalButton.focus();
				
			}, 300);
		}
	});
}

document.addEventListener('keydown', function(e) {
	if(e.key == 'Escape')
		closeModal();
});

if(ieModal) {
	ieModal.querySelector('.close-modal').focus();
	skipLinkToggleDisplay(true);
	setFocus(true, false);
}

const landingModals = [].slice.call(document.querySelectorAll('body.campaign a.modal, #hero a.play-video.modal')),
        modalLanding = document.getElementById('modal-home') ? document.getElementById('modal-home') : document.getElementById('modal-landing'),
        closeBtnLanding = document.getElementById('modal-close');

landingModals.forEach(function(modal) {
    modal.addEventListener('click', function(e) {
        const modalId = this.getAttribute('href').replace('#', '');
        const modalContent = document.getElementById(modalId).innerHTML;
        modalLanding.querySelector('.modal-inner-container').innerHTML = modalContent;
        modalLanding.style.display = 'block';
        e.preventDefault();
        const modalInner = document.getElementById('modal-inner');
        if (this.classList.contains('play-video')) {
            modalInner.style.maxWidth = '80%';
            modalInner.style.padding = '1.5rem 0 0 0';
        } else {
            modalInner.style.maxWidth = '600px';
            modalInner.style.padding = '2rem';
        }

        [].slice.call(document.querySelectorAll('.video-container button')).forEach(function(videoButton) {
            videoButton.addEventListener('click', function() {
                var parent = this.parentNode.parentNode,
                    thumbnail = parent.querySelector('.thumbnail'),
                    video = parent.querySelector('figure.video > *:first-child');

                if(thumbnail)
                    Velocity(thumbnail, {opacity: [0,1]}, {duration: 150, display: 'none'});

                playVideo(video);
            });
        });

        if (modalLanding.querySelector('.video-container button')) {
            modalLanding.querySelector('.video-container button').click();
        }
    })
})

closeBtnLanding?.addEventListener('click', () => {
    modalLanding.style.display = 'none';
    if (modalLanding.querySelector('video')) {
        modalLanding.querySelector('video').pause();
    }

    if (modalLanding.querySelector('iframe')) {
        modalLanding.querySelector('iframe').contentWindow.postMessage(
            JSON.stringify({
                event: 'command',
                func: 'pauseVideo',
                args: [],
            }),
            '*'
        );
    }
});

document.getElementById('modal-backdrop')?.addEventListener('click', () => {
    modalLanding.style.display = 'none';
    if (modalLanding.querySelector('video')) {
        modalLanding.querySelector('video').pause();
    }

    if (modalLanding.querySelector('iframe')) {
        modalLanding.querySelector('iframe').contentWindow.postMessage(
            JSON.stringify({
                event: 'command',
                func: 'pauseVideo',
                args: [],
            }),
            '*'
        );
    }
});

/*=============================
=            Search           =
=============================*/

var searchForm = document.getElementById('site-search'),
	searchInput = searchForm.querySelector('input');

searchForm.addEventListener('submit', function(e) {
	e.preventDefault();

	var input = this.querySelector('input');

	if(input.value !== '')
		window.location.href = '/search?q='+input.value+'#search-results';
	else
		input.classList.add('error');
});

searchForm.querySelector('button').addEventListener('click', function() {
	if(!checkWidth(1200)) {
		if(body.classList.contains('search-open') && searchInput.value === '') {
			body.classList.remove('search-open');
			searchInput.setAttribute('aria-hidden', 'true');
			searchInput.setAttribute('tabindex', '-1');
		}
		else {
			body.classList.add('search-open');
			searchInput.setAttribute('aria-hidden', 'false');
			searchInput.removeAttribute('tabindex');
			searchInput.focus();
		}
	}
});

/*=============================
=             Video           =
=============================*/

[].slice.call(document.querySelectorAll('.video-container button')).forEach(function(videoButton) {
	videoButton.addEventListener('click', function() {
		var parent = this.parentNode.parentNode,
			thumbnail = parent.querySelector('.thumbnail'),
			video = parent.querySelector('figure.video > *:first-child');

		if(thumbnail)
			Velocity(thumbnail, {opacity: [0,1]}, {duration: 150, display: 'none'});

		playVideo(video);
	});
});

function playVideo(video) {
	video.src = video.dataset.src;

	if(video.tagName === 'VIDEO')
		video.autoplay = true;
}

function resetVideo(video) {
	var src = video.src;

	video.src = src.replace('?autoplay=1&rel=0', '');
}

// Play/Pause Background Video
[].slice.call(document.querySelectorAll('#hero .video-controls')).forEach(function(videoButton) {
	videoButton.addEventListener('click', function() {
		var videoPaused = this.classList.contains('play'),
			video = this.parentNode.querySelector('.hero-video');

		if(videoPaused)
			video.play();
		else
			video.pause();

		this.classList.toggle('play');

		this.setAttribute('aria-label', (videoPaused ? 'Pause' : 'Play') + ' Video');
	});
});

[].slice.call(document.querySelectorAll('.video-modal-button, .inline-video-modal-button')).forEach(function(videoButton) {
	videoButton.addEventListener('click', function() {
		var videoIframe = document.createElement('iframe');

		videoIframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
		videoIframe.setAttribute('allowfullscreen', true);
		videoIframe.src = this.getAttribute('video-src');
        videoModalButton = this;

        videoModal.querySelector('.video-container').appendChild(videoIframe);

		Velocity(videoModal, {opacity: [1,0]}, {duration: 300, display: 'block'});

		setTimeout(function() {
			videoModal.querySelector('.close-modal').focus();
			skipLinkToggleDisplay(true);
			setFocus(true, false);
		}, 300);

		var titleElement = this.parentNode.querySelector('h2');

		if(titleElement)
	        videoIframe.setAttribute('title', titleElement.innerHTML);
	});
});

/*=============================
=       Physicians Slider     =
=============================*/

var physiciansSection = document.querySelector('section.physicians.is-slider');

if(physiciansSection) {
	var currentIndex = 0,
		physiciansSlider = physiciansSection.querySelector('.slider-wrapper'),
		cards = physiciansSlider.querySelectorAll('.physician-card'),
		firstCard = cards[0],
        scrollTo = firstCard.offsetWidth,
		prevButton = physiciansSection.querySelector('.controller button.prev'),
		nextButton = physiciansSection.querySelector('.controller button.next'),
		totalPhysiciansCount = 0,
		visibleCardsPerSlide = 0,
		totalSlides = 0;

		function getVisibleCardsPerSlide() {
            if (window.innerWidth <= 767) {
                return 4;
            } else if (window.innerWidth <= 1023) {
                return 2;
            } else {
                return 5;
            }
        }
		function updateTotalSlides() {
            totalPhysiciansCount = cards.length;
            visibleCardsPerSlide = getVisibleCardsPerSlide();

			if (visibleCardsPerSlide === 4) {
				console.log('first math',);
				var twoColumnPhysicians = Math.ceil(totalPhysiciansCount / 2);
				totalSlides = (Math.ceil(twoColumnPhysicians / 2)) + 1;
			} else {
				totalSlides = Math.max(0, Math.ceil((totalPhysiciansCount - visibleCardsPerSlide) + 1));
			}
		
			totalSlides = Math.max(1, totalSlides);

            var totalSlidesElement = physiciansSection.querySelector('.total-slides');
            if (totalSlidesElement) {
                totalSlidesElement.innerText = '0' + totalSlides;
            }
        }

        updateTotalSlides();


	[].slice.call(physiciansSection.querySelectorAll('.controller button')).forEach(function(button) {
		button.addEventListener('click', function() {

            if (button.classList.contains('next')) {

                currentIndex = Math.min(currentIndex + 1, cards.length - 1);
            } else {

                currentIndex = Math.max(currentIndex - 1, 0);
            }

            physiciansSlider.scrollTo({
                left: currentIndex * scrollTo,
                behavior: 'smooth'
            });

            setSliderController();
		});
	});

    setSliderController();

	function setSliderController() {
		var counter = currentIndex+1;

		physiciansSection.querySelector('.counter span').innerHTML = (counter < 10) ? ('0' + counter) : counter;
		
		var cardLength = cards.length;
		if (visibleCardsPerSlide === 4) {
			cardLength = Math.ceil(cards.length / 2);
		}

		prevButton.disabled = currentIndex === 0;
		nextButton.disabled = counter >= totalSlides;
    }
}

/*=============================
=          Statistics         =
=============================*/

[].slice.call(document.querySelectorAll('section.statistics')).forEach(function(statisticsSection) {
	var statisticsAnimation = new Waypoint({
		element: statisticsSection,
		handler: function(direction) {
			[].slice.call(statisticsSection.querySelectorAll('.num')).forEach(function(statistic) {
				var stat = new Odometer({
					el: statistic,
					duration: 3000,
					format: '(,ddd).dd',
				});

				stat.update(statistic.dataset.value);
			});

			this.destroy();
		},
		offset: '85%'
	});
});

/*=============================
=         Testimonials        =
=============================*/

var currentTestimonialIndex = 1,
	testimonialsSection = document.querySelector('section.testimonials');

if(testimonialsSection) {
	var quotesCount = testimonialsSection.querySelectorAll('.quotes-container li').length,
		testimonialsCounter = testimonialsSection.querySelector('.counter span'),
		prevTestimonialButton = testimonialsSection.querySelector('.controller button.prev'),
		nextTestimonialButton = testimonialsSection.querySelector('.controller button.next');

	[].slice.call(testimonialsSection.querySelectorAll('.controller button')).forEach(function(button) {
		button.addEventListener('click', function() {
			var isNext = this.classList.contains('next'),
				currentQuote = testimonialsSection.querySelector('.quotes-container li.current'),
				nextQuote = isNext ? currentQuote.nextSibling : currentQuote.previousSibling,
				currentImage = testimonialsSection.querySelector('.images-container li.current'),
				nextImage = isNext ? currentImage.nextSibling : currentImage.previousSibling;

			currentImage.classList.remove('current');
			currentQuote.classList.remove('current');

			nextImage.classList.add('current');
			Velocity(nextQuote, {opacity: [1,0]}, {duration: 1000});
			nextQuote.classList.add('current');

			currentTestimonialIndex += isNext ? 1 : -1;

			testimonialsCounter.innerHTML = (currentTestimonialIndex < 10) ? ('0' + currentTestimonialIndex) : currentTestimonialIndex;

			prevTestimonialButton.disabled = currentTestimonialIndex === 1;
			nextTestimonialButton.disabled = currentTestimonialIndex == quotesCount;
		});
	});
}

/*=============================
=          Social Feed        =
=============================*/

var socialFeedSection = document.querySelector('section.social'),
	socialFeedContainer = document.querySelector('.social-media-feed-container');

if(socialFeedSection) {
	var socialFeedAnimation = new Waypoint({
		element: socialFeedSection,
		handler: function(direction) {
			displaySocialItems('all');

			this.destroy();
		},
		offset: '85%'
	});
}

[].slice.call(document.querySelectorAll('.social-filter button')).forEach(function(filter) {
	filter.addEventListener('click', function() {
		document.querySelector('.social-filter button[disabled]').disabled = false;
		this.disabled = true;

		[].slice.call(socialFeedSection.querySelectorAll('.social-card')).forEach(function(card) {
			card.style = '';
		});

		displaySocialItems(this.className);
	});
});

function displaySocialItems(social) {
	var isAll = social == 'all',
		socialCards = socialFeedSection.querySelectorAll('.social-card.'+social);

	for(var i=0; i<socialCards.length; i++) {
		var index = i;

		if(isAll) {
			if(i == 1 || i == 3) {
				index = i+3;
				socialCards[i].style.order = '1';
			}
			else if(i == 2)
				index = 1;
			else if(i > 3)
				index = i-2;
		}


		Velocity(socialCards[i], {opacity: [1,0]}, {duration: 300, delay: 75*(index+1), display: 'flex'});
	}
}

/*=============================
=          Google Map         =
=============================*/

var phone = window.innerWidth < 480,
	mobilePhone = window.innerWidth < 1024,
	notDesktop = window.innerWidth < 1200;

export { phone, mobilePhone, notDesktop };

var map = '',
	mapSection = document.querySelector('section.map'),
	strCoordinates = mapSection && mapSection.hasAttribute('coordinates') ? mapSection.getAttribute('coordinates') : '40.7637882, -73.97092429999998',
	coordinates =  JSON.parse('['+ strCoordinates +']'),
	panX = window.innerWidth < 1024 ? (phone ? 0 : -200) : -400,
	panY = phone ? -225 : 0;

Vue.use(VueGoogleMaps, {
	load: {
		key: document.querySelector('meta[name="google-map-api"]').getAttribute('content')
	}
});

if(mapSection) {
	var map = new Vue({
		el: 'section.map',
		// render: h => h(LocationsMap)
		components: {
			LocationsMap
		}
	});
}

/*=============================
=          SalesForce         =
=============================*/

function addScriptToHead(src) {
	var script = document.createElement('script');

    script.src = src;
    script.type = 'text/javascript';
    script.setAttribute('async', 'true');
    script.setAttribute('defer', 'true');

    document.head.appendChild(script);
}

window.addEventListener('load', function() {
	['//cdn.evgnet.com/beacon/reproductivemedny/long_island/scripts/evergage.min.js', '//534006164.collect.igodigital.com/collect.js'].forEach(function(src) {
		addScriptToHead(src);
	});
});

window._etmc = [];

window.runSF = function runSF(type, value) {
	_etmc.push(['setOrgId', '534006164']);

	if(type == 'email' && value)
		_etmc.push(['setUserInfo', {'email': value}]);

	var searchStr = body.id == 'search' ? getParameter(window.location, 'q') : '',
		searchObj = searchStr ? {'search': searchStr} : {};

	_etmc.push(['trackPageView', searchObj]);
}

runSF(false, false);

/*=============================
=         Logos Slider        =
=============================*/

var logosIndex = 0,
	logosLoaded = false,
	logosContainer = document.querySelector('section.is-slider .logos-container'),
	logos = logosContainer ? logosContainer.querySelectorAll('li') : false;

if(logosContainer) {
	var logosWaypoint = new Waypoint({
        element: logosContainer.closest('section.is-slider'),
        handler: function(direction) {
			var logosInterval = setInterval(slideLogos, 1500);

			this.destroy();

        },
        offset: checkWidth(480) && window.innerHeight > 552 ? '80%' : '95%'
    });
}

function slideLogos() {
	var slideTo = logos[0].offsetWidth + parseInt(window.getComputedStyle(logosContainer).gap);

	if(!logosLoaded) {
		for(var i=0; i<7; i++) {
			var clone = logos[i].cloneNode(true);

			logosContainer.append(clone);
		}

		logosLoaded = true;
	}

	logosContainer.style = 'transition: transform 1.5s linear; transform: translateX(-'+(++logosIndex * slideTo)+'px);';

	if(logosIndex == logos.length) {
		setTimeout(function() {
			logosContainer.style = 'transform: translateX(0px);';

			logosIndex = 0;
		}, 1490);
	}
}

/*=============================
=   Select Button enabler     =
=============================*/

function buttonEnabler(selectId, buttonId) {

	let clinicSelect = document.getElementById(selectId);
	let payButton = document.getElementById(buttonId);

	if(!clinicSelect) return;

	clinicSelect.addEventListener("change", function(){

		payButton.removeAttribute('disabled');

	}, {once : true});

	clinicSelect.addEventListener("change", function(){

		payButton.href = clinicSelect.value;

	});
}

// Enable button in /resources/patient-resources/bill-payment page
buttonEnabler('clinic-select','bill');

/*=============================
=      Load 3rd Party JS      =
=============================*/

// window.addEventListener('load', function() {
// 	var js = [
// 		''
// 	];

// 	js.forEach(function(src) {
// 		addJS(src);
// 	});
// });

/*=============================
=         UTM Tracking        =
=============================*/

var referrer = document.referrer,
	existingCookie = Cookie.get('utm_params'),
	currentDomain = !referrer || referrer.indexOf(location.protocol + '//' + location.host) > -1;

if(window.location.href.indexOf('utm_') > -1 || (existingCookie ? !currentDomain : true)) {
	var utmParams = {},
		params = ['source', 'medium', 'campaign', 'content', 'term'];

	params.forEach(function(param) {
		var parameter = 'utm_'+param + '__c',
			isSource = param == 'source',
			value = getParameter(window.location, parameter);

		// If there are no UTM parameters in the URL
		if(!value && (isSource || param == 'medium')) {
			// If Referrer is Google or Bing
			['google', 'bing'].forEach(function(search) {
				if(referrer.indexOf(search) > -1)
					value = isSource ? search : 'organic';
			});

			// If Referrer is not Google or Bing
			if(!value) {
				// If Referrer is not the current domain
				if(!currentDomain)
					value = isSource ? referrer.split('/')[2] : 'referral';
				else
					value = isSource ? '(direct)' : '(none)';
			}
		}

		utmParams[parameter] = value;
	});

	Cookie.set('utm_params', utmParams);
}

/*===================================
=         Parallax Scrolling        =
====================================*/

if (document.querySelector('.parallax')) {
    window.addEventListener('scroll', () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const windowHeight = window.innerHeight;

        const allSections = document.querySelectorAll('section.parallax');
        const lastSection = allSections[allSections.length - 1];

        allSections.forEach(section => {
            const title = section.querySelector('.content-container .title');
            const text = section.querySelector('.content-container .text');

            const applyParallax = (el, speed) => {
                if (!el) return;

                const rect = el.getBoundingClientRect();
                const offset = rect.top + scrollTop;

                if (rect.top < windowHeight && rect.bottom > 0) {
                    let translateY = (scrollTop - offset) * speed;
                    if (translateY > 0) {
                        translateY = 0;
                    }
                    el.style.transform = `translateY(${translateY}px)`;
                } else {
                    el.style.transform = 'translateY(0)';
                }
            };

            let parallaxSpeed = 0.1;
            if (typeof mobilePhone !== 'undefined' && mobilePhone) {
                parallaxSpeed = 0.05;
            }

            applyParallax(title, parallaxSpeed);
            applyParallax(text, parallaxSpeed);
        });
    });
}

if (document.querySelector('.campaign .scroll')) {
    document.querySelector('.campaign .scroll').addEventListener('click', function () {
        let offset = 100;

        if (phone) {
            offset = 110
        }

        const mainElement = document.querySelector('#main');
        const elementPosition = mainElement.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    });
}